import {GameAccountResource} from "../resource/GameAccountResource";
import {IApiGameAccount} from "../typings/apiResponse";
import * as angular from "angular";

export class GameAccountService {

    public static $inject = ["$q", "GameAccountResource"];
    constructor(private $q: angular.IQService,
                private GameAccountResource: GameAccountResource) {
    }

    public get(gameAccountType: string, userId:number|'~' = '~'): angular.IPromise<IApiGameAccount> {
        return this.GameAccountResource.getGameAccount(gameAccountType, userId);
    }

    public getGameAccountsOfPlayer(userId:number|'~' = '~'): angular.IPromise<IApiGameAccount[]> {
        return this.GameAccountResource.getGameAccounts(userId);
    }

    public set(gameAccountType: string, value: string): angular.IPromise<IApiGameAccount> {
        return this.GameAccountResource.setGameAccount(gameAccountType, value);
    }
}